import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Project.css';
const Project = ({ project }) => {
    const { about, client, img, livesite, name, server } = project;
    return (
        <div class="col d-flex justify-content-center">
            <div>
                <div class="card card-container h-100">
                    <div className="card-content text-center">
                        <img src={img} class="card-img-top card-image" alt="..." />
                        <div class="card-body">
                            <h5 class="card-title title-name">{name}</h5>
                            <hr className="w-50 mx-auto hr-line" />
                            <p class="card-text card-para">{about}</p>
                            {/* <a href={livesite} target="_blank" ><button className="click-me-btn">Live Preview</button></a> */}
                            <p className="m-bottom-footer"><span className="links">Links:</span> <small><a href={client} target="_blank" >Github</a> <a target="_blank"  href={livesite}>Live</a></small></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Project;